'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var useIsMobile = require('../../../common/providers/useIsMobile.js');
var nthHookLoma = require('@narvar/nth-hook-loma');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LomaProviders = _ref => {
  let {
    params,
    children
  } = _ref;
  const {
    versionName,
    localeLanguage,
    localeCountry,
    retailerMoniker
  } = params;
  const {
    data,
    loading
  } = nthHookLoma.useGetTrackSegmentedExperienceForClaimsQuery({
    variables: {
      retailerMoniker,
      localeCountry,
      localeLanguage,
      versionName
    }
  });
  const isMobile = useIsMobile["default"]();
  const category = isMobile ? 'MOBILE' : 'DESKTOP';
  if (loading) return null;
  return /*#__PURE__*/React__default["default"].createElement(nthHookTranslations.LomaTranslationsConfigProvider, {
    product: "claims_translations",
    retailerMoniker: retailerMoniker,
    localeLanguage: localeLanguage,
    localeCountry: localeCountry
  }, /*#__PURE__*/React__default["default"].createElement(nthHookSettings.LomaSettingsConfigProvider, {
    product: "claims",
    retailerMoniker: retailerMoniker,
    versionName: "",
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    category: category
  }, /*#__PURE__*/React__default["default"].createElement(nthHookTheme.LomaThemeConfigProvider, {
    product: "narvarjs",
    retailerMoniker: retailerMoniker,
    versionName: (data === null || data === void 0 ? void 0 : data.segmentedExperience.versionName) || '',
    localeLanguage: localeLanguage,
    localeCountry: localeCountry
  }, children)));
};

exports["default"] = LomaProviders;
